import { dispatchAction } from '@ardoq/rxbeach';
import * as actions from './actions';
import { ExpandableSectionId } from './types';

export const getMetamodelViewCommands = (namespace: string) => ({
  toggleIsSelectedGraphNode: (graphNodeId: string) => {
    dispatchAction(
      actions.toggleIsSelectedGraphNode({ graphNodeId }),
      namespace
    );
  },

  toggleExpandableSection: (expandableId: ExpandableSectionId) =>
    dispatchAction(
      actions.toggleExpandableSection({ expandableId }),
      namespace
    ),
});

export type MetamodelViewCommands = ReturnType<typeof getMetamodelViewCommands>;
